import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

export default ({ error, children, ...props }) => (
  <Label {...props}>{children}</Label>
)

const Label = glamorous.label(
  {
    color: style.colors.brown,
    padding: "0.5rem 0 0.5rem 0",
  },
  ({ inline, type }) => ({
    width: inline && "25%",
    textAlign: inline && "right",
    fontWeight: inline && 600,
    paddingRight: inline && "1rem",
    [style.size.mobile]: inline && {
      width: "100%",
      textAlign: "center",
      paddingRight: 0,
    },
  })
)



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/FieldParts/Label/index.js